export default __webpack_public_path__ + "static/media/line_placeholder.4efd302a.svg";